module.exports = __webpack_public_path__ + "static/media/straighten_06.a987963f.png";